/* unplugin-vue-components disabled */import { render } from "./CoreComponent.vue?vue&type=template&id=6003e1f5"
import script from "./CoreComponent.vue?vue&type=script&lang=js"
export * from "./CoreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__